import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { RGPDPreferences } from 'src/app/api/models/rgpdLabs';
import { RgpdService } from 'src/app/api/services';

@Component({
    selector: 'app-rgpd-manager',
    templateUrl: './rgpd-manager.component.html',
    styleUrls: ['./rgpd-manager.component.css'],
    standalone: false
})
export class RgpdManagerComponent {
  loading: boolean = false;
  selectedFile: File | null = null;
  clientsPreferences: RGPDPreferences[] = [];
  displayedColumns: string[] = ["numero","nome", "decisao", "dataHora", "bloqueados"];
  totalCount = 0;
  pageSize = 10;
  currentPage = 0;
  searchTerm: string = '';

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private rgpdService: RgpdService
  ) {}

  ngOnInit(): void {
    this.loadClientsData(0, this.pageSize);
  }

  loadClientsData(pageIndex: number, pageSize: number): void {
    this.loading = true;
    this.rgpdService.getAllPreferences(pageIndex + 1, pageSize, this.searchTerm).subscribe({
      next: (res) => {
        this.clientsPreferences = res.data;
        this.totalCount = res.totalCount;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error("Erro ao carregar as preferências dos clientes", err);
      }
    });
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadClientsData(this.currentPage, this.pageSize);
  }

  onSearch() {
    this.currentPage = 0;
    this.loadClientsData(this.currentPage, this.pageSize);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  importar(): void {
    if (!this.selectedFile) {
      alert("Selecione um ficheiro primeiro.");
      return;
    }
    this.loading = true;
    this.rgpdService.uploadClientsRGPDFile(this.selectedFile).subscribe({
      next: () => {
        this.loading = false;

        // Clear file input
        this.selectedFile = null;
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }

        this.loadClientsData(0, this.pageSize);
      },
      error: () => this.loading = false
    });
  }

  exportAllPreferencesCSV() {
    this.loading = true;

    this.rgpdService.exportAllPreferences().subscribe({
      next: (file: Blob) => {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'RGPD_PreferenciasDosClientes.csv';
        a.click();
        window.URL.revokeObjectURL(url);

        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error("Erro ao exportar as preferências dos clientes", err);
      }
    });
  }

}
